import { EEventCategory, IMeetingSession } from '@turing/interfaces/event';
import { getRandomNumber, getRandomTime, sortASCTime } from '@turing/helpers';

export const getMeetingSessionEventsAPI = (): Promise<IMeetingSession[]> => {
  let meetingOpenSessionData: IMeetingSession[] = [];

  const exampleTitles: string[] = [
    'Open session (JTL Timofei)',
    'A/B testing and regressions operations analyzing together forever!',
    'Open session (JTL Lukas)',
  ];

  const today = new Date();
  const tomorrow = new Date(new Date(today).setDate(today.getDate() + 1));
  const tomorrowsDate = tomorrow.getDate();

  const initialData: IMeetingSession = {
    id: 1,
    summary: 'Stand-up',
    url: 'https://example.com/meeting1',
    category: EEventCategory.Meeting,
    start: new Date().toISOString(),
    end: new Date(new Date().setHours(new Date().getHours() + 1)).toISOString(),
  };
  meetingOpenSessionData.push(initialData);

  for (let i = 1; i < 6; i++) {
    const previousData = meetingOpenSessionData[i - 1];
    let newStart = new Date(previousData.start);
    let newEnd = new Date(previousData.end);

    if (i % 2 !== 0) {
      newStart.setDate(newStart.getDate());
      newEnd.setDate(newEnd.getDate());
    } else {
      newStart.setDate(newStart.getDate() + 1 > tomorrowsDate ? newStart.getDate() : newStart.getDate() + 1);
      newEnd.setDate(newEnd.getDate() + 1 > tomorrowsDate ? newEnd.getDate() : newEnd.getDate() + 1);
    }

    let startTime = getRandomTime(newStart);
    let endTime = new Date(new Date(startTime).setHours(startTime.getHours() + 1));

    const randomTitle = getRandomNumber(0, 2);

    let newData = {
      id: previousData.id + 1,
      summary: i % 2 === 0 ? 'Stand-up' : exampleTitles[randomTitle], //`Meeting ${previousData.id + 1}`,
      url: `https://example.com/meeting${previousData.id + 1}`,
      category: i % 2 === 0 ? EEventCategory.Meeting : EEventCategory.OpenSession,
      start: startTime.toISOString(),
      end: endTime.toISOString(),
    };
    meetingOpenSessionData.push(newData);
  }

  return Promise.resolve(sortASCTime(meetingOpenSessionData) as IMeetingSession[]);
};
